export const ROUTES = {
    root: '/',
    dashboard: '/dashboard',
    notifications: '/notifications',

    auth: {
        login: '/auth/login',
        otp: '/auth/otp',
        forgotPassword: '/auth/forgot-password',
        resetPassword: '/auth/reset-password',
        register: '/auth/register',
        selectStore: '/auth/select-store',
        changePassword: '/auth/change-password',
        /** EG-356 Sprint 6 (04b9120) — đặt password lần đầu sau register OTP */
        setPassword: '/auth/set-password',
    },

    pos: '/pos',
    posCustomerDisplay: '/pos/customer-display',
    posShifts: {
        list: '/pos/shifts',
        detail: (id: string) => `/pos/shifts/${id}`,
    },

    buyback: {
        list: '/buyback',
        new: '/buyback/new',
        detail: (id: string) => `/buyback/${id}`,
        reports: '/reports/buyback',
    },

    exchanges: {
        list: '/exchanges',
        new: '/exchanges/new',
        detail: (id: string) => `/exchanges/${id}`,
        approve: (id: string) => `/exchanges/${id}/approve`,
        reports: '/reports/exchange',
    },

    products: {
        list: '/products',
        new: '/products/new',
        detail: (id: string) => `/products/${id}`,
        edit: (id: string) => `/products/${id}/edit`,
        units: '/products/units',
        categories: {
            list: '/products/categories',
        },
        metalCategories: {
            list: '/products/metal-categories',
        },
        brands: {
            list: '/products/brands',
        },
        attributes: {
            list: '/products/attributes',
        },
    },
    orders: {
        list: '/orders',
        detail: (id: string) => `/orders/${id}`,
    },
    inventory: {
        list: '/inventory',
        receipts: '/inventory/receipts',
        receiptNew: '/inventory/receipts/new',
        receiptDetail: (id: string) => `/inventory/receipts/${id}`,
        receiptEdit: (id: string) => `/inventory/receipts/${id}/edit`,
        issues: '/inventory/issues',
        issueNew: '/inventory/issues/new',
        issueDetail: (id: string) => `/inventory/issues/${id}`,
        issueEdit: (id: string) => `/inventory/issues/${id}/edit`,
        transfers: '/inventory/transfers',
        transferNew: '/inventory/transfers/new',
        transferDetail: (id: string) => `/inventory/transfers/${id}`,
        transferEdit: (id: string) => `/inventory/transfers/${id}/edit`,
        transferApprove: (id: string) => `/inventory/transfers/${id}/approve`,
        counts: '/inventory/counts',
        countNew: '/inventory/counts/new',
        countEnter: (id: string) => `/inventory/counts/${id}/enter`,
        countVariance: (id: string) => `/inventory/counts/${id}/variance`,
        movements: '/inventory/movements',
        alerts: '/inventory/alerts',
        reports: '/inventory/reports',
        printLabels: '/inventory/print-labels',
        costing: '/inventory/costing',
        warehouses: '/inventory/warehouses',
    },
    staff: {
        list: '/staff',
        detail: (id: string) => `/staff/${id}`,
        invite: '/staff/invite',
        edit: (id: string) => `/staff/${id}/edit`,
        activity: (id: string) => `/staff/${id}/activity`,
        stores: (id: string) => `/staff/${id}/stores`,
        // EG-510 — Payroll Profile tab for staff detail
        payrollProfile: (id: string) => `/staff/${id}/payroll-profile`,
    },
    reports: {
        index: '/reports',
        revenue: '/reports/revenue',
        inventory: '/reports/inventory',
        eod: '/reports/eod',
        pawn: '/reports/pawn',
        installment: '/reports/installment',
        workshop: '/reports/workshop',
        exchange: '/reports/exchange',
        buyback: '/reports/buyback',
        accounting: '/accounting/reports',
        businessResults: '/accounting/reports/business-results',
        balanceSheet: '/accounting/reports/balance-sheet',
        trialBalance: '/accounting/reports/trial-balance',
        s2bRevenue: '/accounting/reports/s2b-revenue',
        s2cIncomeExpense: '/accounting/reports/s2c-income-expense',
        s2dMaterials: '/accounting/reports/s2d-materials',
        s2eCash: '/accounting/reports/s2e-cash',
        inventorySummary: '/accounting/reports/inventory-summary',
        cashBook: '/accounting/reports/cash-book',
        bankDepositBook: '/accounting/reports/bank-deposit-book',
        cashReceiptJournal: '/accounting/reports/cash-receipt-journal',
        cashPaymentJournal: '/accounting/reports/cash-payment-journal',
        cashFlowStatement: '/accounting/reports/cash-flow-statement',
        documentListing: '/accounting/reports/document-listing',
        voucherListing: '/accounting/reports/voucher-listing',
        invoiceListing: '/accounting/reports/invoice-listing',
        warehouseVoucherListing: '/accounting/reports/warehouse-voucher-listing',
        receivablePayableListing: '/accounting/reports/receivable-payable-listing',
    },
    /** EG-504..EG-529 — Payroll module (Sprint 5.1) */
    payroll: {
        dashboard: '/payroll',
        components: '/payroll/components',
        runs: '/payroll/runs',
        runDetail: (id: string) => `/payroll/runs/${id}`,
        payslips: '/payroll/payslips',
        settings: '/payroll/settings',
        reports: {
            s5hkd: '/payroll/reports/s5-hkd',
            qttTncn: '/payroll/reports/qtt-tncn',
        },
    },
    customers: {
        list: '/customers',
        new: '/customers/new',
        detail: (id: string) => `/customers/${id}`,
        purchases: (id: string) => `/customers/${id}/purchases`,
        loyalty: (id: string) => `/customers/${id}/loyalty`,
        loyaltySettings: '/customers/loyalty-settings',
        credits: (id: string) => `/customers/${id}/credits`,
    },
    goldPrice: {
        board: '/gold-price',
        history: '/gold-price/history',
        currentQuotes: '/gold-price/current-quotes',  // MỚI Plan 2
        instruments: '/gold-price/instruments',  // MỚI Plan 3
        settings: '/gold-price/settings',
        tv: '/gold-price/tv',
        widget: '/gold-price/widget',
        priceProtection: '/gold-price/price-protection',
        priceProtectionLogs: '/gold-price/price-protection/logs',
    },
    suppliers: {
        list: '/suppliers',
        new: '/suppliers/new',
        detail: (id: string) => `/suppliers/${id}`,
        history: (id: string) => `/suppliers/${id}/history`,
    },
    salesInvoices: {
        list: '/accounting/sales/documents',
        new: '/accounting/sales/documents/new',
        detail: (id: string) => `/accounting/sales/documents/${id}`,
        edit: (id: string) => `/accounting/sales/documents/${id}/edit`,
    },
    purchasing: {
        list: '/accounting/purchasing',
        new: '/accounting/purchasing/new',
        detail: (id: string) => `/accounting/purchasing/${id}`,
        receive: (id: string) => `/accounting/purchasing/${id}/receive`,
        match: (id: string) => `/accounting/purchasing/${id}/match`,
        reports: '/accounting/purchasing/reports',
    },
    promotions: {
        list: '/promotions',
        new: '/promotions/new',
        edit: (id: string) => `/promotions/${id}/edit`,
        vouchers: '/promotions/vouchers',
        voucherNew: '/promotions/vouchers/create',
        voucherEdit: (id: string) => `/promotions/vouchers/${id}/edit`,
        flashSales: '/promotions/flash-sales',
        loyalty: '/promotions/loyalty',
        wholesaleGifts: '/promotions/wholesale-gifts',
        reports: '/promotions/reports',
    },
    workshop: {
        list: '/workshop',
        new: '/workshop/new',
        detail: (id: string) => `/workshop/${id}`,
        craftsmen: '/workshop/craftsmen',
        services: '/workshop/services',
        commissions: '/workshop/commissions',
        reports: '/reports/workshop',
    },
    jewelryScale: {
        index: '/jewelry-scale',
    },
    commission: {
        index: '/commissions',
        my: '/commissions/my',
        kpi: '/commissions/kpi',
        kpiTargets: '/commissions/kpi-targets',
        leaderboard: '/commissions/leaderboard',
        config: '/commissions/config',
        configGeneral: '/commissions/config/general',
        roles: '/commissions/config/roles',
        productRates: '/commissions/config/product-rates',
        bonusThresholds: '/commissions/config/bonus-thresholds',
        adjustments: '/commissions/adjustments',
        payouts: '/commissions/payouts',
        liveSessions: '/commissions/live-sessions',
        reports: '/commissions/reports',
        review: '/commissions/review',
        reviewDetail: (period: string, staffId: string) => `/commissions/review/${period}/${staffId}`,
    },
    goldTrading: {
        board: '/gold-trading',
        buy: '/gold-trading/buy',
        sell: '/gold-trading/sell',
        history: '/gold-trading/history',
        settings: '/gold-trading/settings',
        reports: '/gold-trading/reports',
    },
    onboarding: {
        index: '/onboarding',
        business: '/onboarding/business',
        store: '/onboarding/store',
        staff: '/onboarding/staff',
        products: '/onboarding/products',
        payment: '/onboarding/payment',
        invoice: '/onboarding/invoice',
        complete: '/onboarding/complete',
    },
    setup: {
        index: '/setup',
        branding: '/setup/branding',
        catalog: '/setup/catalog',
        plugin: '/setup/plugin',
        hardware: '/setup/hardware',
        demo: '/setup/demo',
        complete: '/setup/complete',
    },
    pawn: {
        list: '/pawn',
        new: '/pawn/new',
        detail: (id: string) => `/pawn/${id}`,
        dueToday: '/pawn/due-today',
        overdue: '/pawn/overdue',
        settings: '/pawn/settings',
        reports: '/reports/pawn',
    },
    installment: {
        list: '/installment',
        new: '/installment/new',
        detail: (id: string) => `/installment/${id}`,
        collect: (id: string) => `/installment/${id}/collect`,
        collections: '/installment/collections',
        schedule: (id: string) => `/installment/${id}/schedule`,
        settings: '/installment/settings',
        reports: '/reports/installment',
    },
    consignment: {
        list: '/consignment',
        new: '/consignment/new',
        detail: (id: string) => `/consignment/${id}`,
        payout: (id: string) => `/consignment/${id}/payout`,
        reports: '/consignment/reports',
    },
    labels: {
        list: '/labels',
        new: '/labels/new',
        edit: (id: string) => `/labels/${id}/edit`,
        preview: (id: string) => `/labels/${id}/preview`,
        print: '/labels/print',
        printerSettings: '/labels/printer-settings',
    },
    finance: {
        eod: '/finance/eod',
        cashBook: '/finance/cash-book',
        vouchers: '/finance/vouchers',
        vouchersNew: '/finance/vouchers/new',
        invoices: '/finance/invoices',
        invoicesIssue: '/finance/invoices/issue',
        invoiceDetail: (id: string) => `/finance/invoices/${id}`,
        invoiceAdjust: (id: string) => `/finance/invoices/${id}/adjust`,
        eodDetail: (date: string) => `/finance/eod/${date}`,
        einvoiceSettings: '/finance/einvoice-settings',
        einvoiceList: '/finance/einvoices',
        einvoiceDetail: (id: string) => `/finance/einvoices/${id}`,
        einvoiceNew: '/finance/einvoices/new',
        misa: '/finance/misa',
        misaLogs: '/finance/misa/logs',
        paymentMethods: '/finance/payment-methods',
    },
    stores: {
        list: '/stores',
        new: '/stores/new',
        detail: (id: string) => `/stores/${id}`,
        edit: (id: string) => `/stores/${id}/edit`,
        hardware: (id: string) => `/stores/${id}/hardware`,
    },
    reportsAdvanced: {
        profit: '/reports/profit',
        staff: '/reports/staff',
        customers: '/reports/customers',
        products: '/reports/products',
        multiStore: '/reports/multi-store',
        builder: '/reports/builder',
        einvoiceStats: '/finance/einvoice/reports/stats',
        einvoiceTax: '/finance/einvoice/reports/tax',
    },
    imports: {
        index: '/import',
        products: '/import/products',
        customers: '/import/customers',
        suppliers: '/import/suppliers',
    },
    // EG-348 Phase D — CRM 360 (port từ ancarat-bo)
    crm: {
        dashboard: '/crm',
        followUps: '/crm/follow-ups',
    },
    referral: {
        overview: '/referral',
        list: '/referral/list',
        leaderboard: '/referral/leaderboard',
        config: '/referral/config',
    },
    audit: {
        log: '/settings/audit-log',
        apiKeys: '/settings/api-keys',
    },
    shipping: {
        list: '/shipping',
        new: '/shipping/new',
        detail: (id: string) => `/shipping/${id}`,
        pickupLocations: '/shipping/pickup-locations',
        ghtkLogs: '/shipping/ghtk-logs',
        map: '/shipping/map',
    },
    support: {
        home: '/support',
        tickets: '/support/tickets',
        ticketNew: '/support/tickets/new',
        changelog: '/support/changelog',
    },
    accounting: {
        dashboard: '/accounting/dashboard',
        transactions: '/accounting/cash-bank/transactions',
        receiptNew: '/accounting/cash-bank/receipts/new',
        receiptEdit: (id: string) => `/accounting/cash-bank/receipts/${id}`,
        paymentNew: '/accounting/cash-bank/payments/new',
        paymentEdit: (id: string) => `/accounting/cash-bank/payments/${id}`,
        internalTransferNew: '/accounting/cash-bank/internal-transfers/new',
        internalTransferEdit: (id: string) => `/accounting/cash-bank/internal-transfers/${id}`,
        prepaidExpenses: '/accounting/assets/prepaid-expenses',
        prepaidExpenseNew: '/accounting/assets/prepaid-expenses/new',
        prepaidExpenseEdit: (id: string) => `/accounting/assets/prepaid-expenses/${id}`,
        fixedAssets: '/accounting/assets/fixed-assets',
        fixedAssetNew: '/accounting/assets/fixed-assets/new',
        fixedAssetEdit: (id: string) => `/accounting/assets/fixed-assets/${id}`,
        fixedAssetDetail: (id: string) => `/accounting/assets/fixed-assets/${id}`,
        fixedAssetGroups: '/accounting/assets/fixed-asset-groups',
        toolSupplies: '/accounting/assets/tool-supplies',
        toolSupplyReports: '/accounting/assets/tool-supplies/reports',
        toolSupplyNew: '/accounting/assets/tool-supplies/new',
        toolSupplyEdit: (id: string) => `/accounting/assets/tool-supplies/${id}`,
        toolSupplyDetail: (id: string) => `/accounting/assets/tool-supplies/${id}`,
        otherDocument: '/accounting/documents/other',
        // Accounting canonical routes (Phase 2). Legacy /sales/* and old purchase paths redirect in App.tsx.
        salesDocuments: '/accounting/sales/documents',
        salesDocumentNew: '/accounting/sales/documents/new',
        salesDocumentReturnsNew: '/accounting/sales/documents/returns/new',
        salesDocumentDiscountsNew: '/accounting/sales/documents/discounts/new',
        salesEinvoices: '/accounting/invoices/outgoing',
        // Compatibility aliases — route to canonical accounting URLs.
        salesInvoices: '/accounting/sales/documents',
        salesInvoiceNew: '/accounting/sales/documents/new',
        adjustmentInvoices: '/accounting/invoices/outgoing?type=adjustment',
        replacementInvoices: '/accounting/invoices/outgoing?type=replacement',
        salesReturns: '/accounting/invoices/outgoing?type=return',
        purchaseDocuments: '/accounting/purchase/documents',
        purchaseDocumentNew: '/accounting/purchase/documents/new',
        purchaseInputInvoices: '/accounting/invoices/incoming',
        purchaseReturnsNew: '/accounting/purchase/returns/new',
        purchaseReturns: '/accounting/purchase/returns',
        purchaseDiscountsNew: '/accounting/purchase/discounts/new',
        purchaseDiscounts: '/accounting/purchase/discounts',
        // Aliases — keep names for existing callers.
        purchaseInvoices: '/accounting/purchase/documents',
        purchaseInvoiceNew: '/accounting/purchase/documents/new',
        govInvoices: '/accounting/invoices/incoming',
        inventoryReceipts: '/accounting/inventory/receipts',
        inventoryIssues: '/accounting/inventory/issues',
        inventoryTransfers: '/accounting/inventory/transfers',
        productsUom: '/accounting/inventory/products-uom',
        customersAR: '/accounting/ar/customers',
        reports: '/accounting/reports',
        reportBusinessResults: '/accounting/reports/business-results',
        reportBalanceSheet: '/accounting/reports/balance-sheet',
        reportTrialBalance: '/accounting/reports/trial-balance',
        reportS2b: '/accounting/reports/s2b-revenue',
        reportS2c: '/accounting/reports/s2c-income-expense',
        reportS2d: '/accounting/reports/s2d-materials',
        reportS2e: '/accounting/reports/s2e-cash',
        reportInventorySummary: '/accounting/reports/inventory-summary',
        reportCashBook: '/accounting/reports/cash-book',
        reportBankDepositBook: '/accounting/reports/bank-deposit-book',
        reportCashReceiptJournal: '/accounting/reports/cash-receipt-journal',
        reportCashPaymentJournal: '/accounting/reports/cash-payment-journal',
        reportCashFlowStatement: '/accounting/reports/cash-flow-statement',
        reportDocumentListing: '/accounting/reports/document-listing',
        reportVoucherListing: '/accounting/reports/voucher-listing',
        reportInvoiceListing: '/accounting/reports/invoice-listing',
        reportWarehouseVoucher: '/accounting/reports/warehouse-voucher-listing',
        reportReceivablePayable: '/accounting/reports/receivable-payable-listing',
        reportCustomersAR: '/accounting/reports/customers-ar',
        settings: '/accounting/settings',
        dataRepair: '/accounting/data-repair',
    },

    settings: {
        index: '/settings',
        business: '/settings/business',
        appearance: '/settings/appearance',
        hardware: '/settings/hardware',
        billing: '/settings/billing',
        billingHistory: '/settings/billing/history',
        billingUpgrade: '/settings/billing/upgrade',
        billingPayment: '/settings/billing/payment',
        billingQR: '/settings/billing/payment/qr',
        billingResult: '/settings/billing/payment/result',
        roles: '/settings/roles',
        roleDetail: (id: string) => `/settings/roles/${id}`,
        profile: '/settings/profile',
        security: '/settings/security',
        notifications: '/settings/notifications',
        general: '/settings/general',
        locale: '/settings/locale',
        dataExport: '/settings/data-export',
        // EG-345 P4 — wire mới (P3 einvoice + payment dùng ROUTES.finance.*)
        apiKeys: '/settings/api-keys',
        auditLog: '/settings/audit-log',
        // EG-508 — Payroll settings
        payroll: '/settings/payroll',
        receiptTemplates: '/settings/receipt-templates',
        receiptTemplateNew: '/settings/receipt-templates/new',
        receiptTemplateEdit: (id: string) => `/settings/receipt-templates/${id}/edit`,
        accounting: '/accounting/settings',
    },
    // EG-520 — Payslip history (self-service)
    me: {
        payslips: '/me/payslips',
    },
} as const;

/** Legacy: keep `login` top-level for back-compat (= ROUTES.auth.login). */
export const LEGACY_LOGIN = ROUTES.auth.login;
